import React from 'react'
import { StatsCarousel } from './statsCarousel'

export const NoConversationTips: React.FC = () => {
  return (
    <div className="hidden h-full w-full flex-col items-center justify-center pb-36 sm:flex">
      <StatsCarousel />
    </div>
  )
}
